var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9902 8.55616L11.9564 9.24616L13.1237 7.9668",
    stroke: "#FFC400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 12.1923C14.0378 12.1923 15.6434 10.5866 15.6434 8.60589C15.6434 6.6252 14.0378 5.01953 12.0571 5.01953C10.0764 5.01953 8.4707 6.6252 8.4707 8.60589C8.4707 10.5866 10.0764 12.1923 12.0571 12.1923Z",
    stroke: "#FFC400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96289 12.3775V4.54238C4.96289 3.13826 6.10116 2 7.50527 2H16.4936C17.8977 2 19.036 3.13826 19.036 4.54238V12.3775",
    stroke: "#FFC400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4856 15.2326V13.314C20.4856 12.6196 19.7553 12.1676 19.1338 12.4773L12.4175 15.824C12.155 15.9549 11.8462 15.9549 11.5836 15.824L4.86736 12.4773C4.24588 12.1676 3.51562 12.6196 3.51562 13.314V19.4581C3.51562 20.8622 4.65389 22.0005 6.058 22.0005H17.9432C19.3434 22.0005 20.4791 20.8685 20.4854 19.4699",
    stroke: "#FFC400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter1);
export default __webpack_public_path__ + "static/media/Newsletter1.c0cfeca424140b98db22a45e32de62ab.svg";
export { ForwardRef as ReactComponent };